import { selectIsLoggedIn } from "@sunrise/jwt";
import { socketAtom } from "@sunrise/yallo-websocket";
import { atomEffect } from "jotai-effect";
import { freeUsageAtom } from "./free-usage.atom";
import { httpClientAtom } from "@sunrise/http-client";

export const reactForUserToSocketEffect = atomEffect((get, set) => {
  const ws = get(socketAtom);
  const isLoggedIn = get(selectIsLoggedIn);

  if (!ws || !isLoggedIn) {
    return;
  }

  ws.on("live-streaming-limit-reached", () => {
    set(freeUsageAtom, true);
  });

  ws.on("subscription_changed", () => {
    // refresh access token, with new subscription options
    const client = get(httpClientAtom);
    client.privateApi?.refreshToken();
  });

  return () => {
    set(freeUsageAtom, false);

    // TODO: add a ws.off to the socket.
  };
});
